// Gemini chat client.
// The API key lives server-side as a Firebase Functions secret and is called
// via the `chatWithGemini` callable function in functions/index.js.
import { getFunctions, httpsCallable } from 'firebase/functions';
import { getApp } from 'firebase/app';

let cachedCallable = null;
const getCallable = () => {
  if (cachedCallable) return cachedCallable;
  const functionsInstance = getFunctions(getApp(), 'us-east1');
  cachedCallable = httpsCallable(functionsInstance, 'chatWithGemini');
  return cachedCallable;
};

export const callGeminiAPI = async (messages, profileData, userQuery) => {
  try {
    const callable = getCallable();
    const result = await callable({
      messages: Array.isArray(messages) ? messages : [],
      profileData: profileData || {},
      userQuery: typeof userQuery === 'string' ? userQuery : ''
    });
    const text = result?.data?.text;
    if (!text) return "I'm here! How can I help you? 👋";
    return text;
  } catch (error) {
    const code = error?.code || '';
    console.error('chatWithGemini callable error:', code, error?.message);

    if (code === 'functions/resource-exhausted' || code === 'resource-exhausted') {
      return "I'm getting too many requests right now. Please wait a moment and try again! ⏳";
    }
    if (code === 'functions/unauthenticated' || code === 'functions/permission-denied') {
      return "I'm having authentication issues. Please contact support if this persists. 🔐";
    }
    if (error?.message?.includes('Failed to fetch') || error?.message?.includes('NetworkError')) {
      return "I'm having trouble connecting right now. Please check your internet and try again! 🌐";
    }
    return "I'm having trouble processing that right now. Could you try again in a moment? 🧠✨";
  }
};
